import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import VueFeather from "vue-feather";
Vue.use(VueFeather);

import VueTimeago from "vue-timeago";

Vue.use(VueTimeago, {
  name: "Timeago", // Component name, `Timeago` by default
  locale: "en" // Default locale
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
